import { render, staticRenderFns } from "./UnitsComponent.vue?vue&type=template&id=1b254c2a&"
import script from "./UnitsComponent.vue?vue&type=script&lang=js&"
export * from "./UnitsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports